export default __webpack_public_path__ + "static/media/719b4b8dfaf213eb0aa45bd4ae1023071575565996253.4188c452.webp";